/** Operadores suportados pelo construtor visual (geram expressão compatível com o motor existente). */
export type VisualCondOp = '==' | '!=' | '>' | '<' | '>=' | '<='

const OP_LABELS: Record<VisualCondOp, string> = {
  '==': 'é igual a',
  '!=': 'é diferente de',
  '>': 'é maior que',
  '<': 'é menor que',
  '>=': 'é maior ou igual a',
  '<=': 'é menor ou igual a'
}

export function getOperatorLabels(): { value: VisualCondOp; label: string }[] {
  return (Object.keys(OP_LABELS) as VisualCondOp[]).map((value) => ({
    value,
    label: OP_LABELS[value]
  }))
}

export type ParsedSimpleCondition = {
  left: string
  op: VisualCondOp
  right: string
  /** Se true, valor sem aspas (número). */
  numeric: boolean
}

/**
 * Extrai campo, operador e valor de expressões simples do tipo `plano == "4"` ou `x > 10`.
 * Expressões complexas devolvem null (usar modo avançado).
 */
export function parseSimpleCondition(raw: string): ParsedSimpleCondition | null {
  const s = raw.trim()
  if (!s) return { left: '', op: '==', right: '', numeric: false }

  const quoted = s.match(
    /^\s*([a-zA-Z_][\w.]*)\s*(==|!=|>=|<=|>|<)\s*"((?:[^"\\]|\\.)*)"\s*$/
  )
  if (quoted) {
    const right = quoted[3].replace(/\\"/g, '"').replace(/\\\\/g, '\\')
    return {
      left: quoted[1],
      op: quoted[2] as VisualCondOp,
      right,
      numeric: false
    }
  }

  const numeric = s.match(/^\s*([a-zA-Z_][\w.]*)\s*(==|!=|>=|<=|>|<)\s*(-?\d+)\s*$/)
  if (numeric) {
    return {
      left: numeric[1],
      op: numeric[2] as VisualCondOp,
      right: numeric[3],
      numeric: true
    }
  }

  return null
}

/** Monta a expressão guardada em `condition` (string). */
export function buildSimpleCondition(parts: ParsedSimpleCondition): string {
  const L = parts.left.trim()
  const R = parts.right.trim()
  if (!L) return ''
  if (parts.numeric && /^-?\d+$/.test(R)) {
    return `${L} ${parts.op} ${R}`
  }
  const escaped = R.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
  return `${L} ${parts.op} "${escaped}"`
}
